













import { Component, Prop, Vue } from 'vue-property-decorator'
import { bindMap } from '@/utils/status-map'

@Component
export default class StatusBind extends Vue {
    statusMap = bindMap
    @Prop() status!: number
}
